import { windowUtils } from 'utils/windowUtils/windowUtils';

const composeUrl = () => {
  const port = windowUtils.getPort();
  const protocol = windowUtils.getProtocol();
  const hostname = windowUtils.getHostname();
  const url = `${protocol}//${hostname}`;

  if (port) {
    return `${url}:${port}`;
  }

  return url;
};

export const getCurrentUrl = () => windowUtils.getOrigin() || composeUrl();

export const url = {
  getCurrentUrl,
};
